/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';

export namespace AgentCardInfoWrapper {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {}
}

const styles = StyleSheet.create({
  agentCardInfoWrapper: {
    width: '100%', // Needed to make very long words in LoanAgentDetails overflow correctly in IE (for some reason)
  },
});

export const AgentCardInfoWrapper: React.FC<AgentCardInfoWrapper.Props> = ({ children, ...htmlProps }) => {
  return (
    <div className={css(styles.agentCardInfoWrapper)} {...htmlProps}>
      {children}
    </div>
  );
};
